import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionmilo() {
  return (
    <section
      className="solutionmilo p-100 text_reck"
      style={{ background: "#FBFBFB" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img">
              <StaticImage
                src="../../../images/case-studies/reckncase/solution.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={608}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              Solutions <span>Delivered</span>
            </h2>
            <p>
              TekRevol’s skill shone through in the all-inclusive solutions
              brought through the Reck’N app. The user-friendly mobile
              application for customers abridged the reservation process,
              guaranteeing problem-free bookings. The app allowed fast and
              effectual order processing for restaurants, refining the overall
              dining experience.
            </p>
            <p>
              The advanced features of Reck’N altered dining dynamics. Customers
              could now order straight from their seats, receiving push
              notifications when their orders were prepared for pickup. The
              app’s exclusive socialization feature permitted customers to link
              by sending treats to each other, nurturing a sense of community.
              Shared interests enabled organic exchanges among diners.
            </p>
            <p>
              For restaurants, Reck’N carried extraordinary benefits. The skill
              to track customer behavior and likings translated into enhanced
              sales. Restaurants could also encompass unique treatments to their
              regular customers, improving loyalty.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionmilo;
